import {
  StatsigState,
  SubscriptionPayload,
  SubscriptionSignUpOrderSummaryResponse,
} from 'models';

export const SUBSCRIPTION_PAYLOAD_STATE: SubscriptionPayload = {
  orderSummary: {} as SubscriptionSignUpOrderSummaryResponse,
  err: {},
} as SubscriptionPayload;

export const StatsigInitialState: StatsigState = {
  user: null,
};
